export enum SalaryComponentUnit {
  CZK = "CZK",
  Day = "Day",
  Hour = "Hour",
}
